import IbanService from "@/api/services/iban";

export default {
  namespaced: true,
  actions: {
    async updateCustomerIban({ dispatch, rootState }, { customerId, iban, document }) {
      const formData = new FormData();
      formData.append("iban", iban);
      formData.append("customer_id", customerId);
      formData.append("document", document);

      const response = await IbanService.updateCustomerIban(formData);

      if (!response?.success) return response;

      dispatch("claims/fetch", rootState.claims.currentClaim.friendlyId, { root: true });

      return response;
    },

    async confirmCustomerIban({ dispatch, rootState }, { customerId }) {
      const response = await IbanService.confirmCustomerIban(customerId);
      if (!response?.success) return response;

      await dispatch("claims/fetch", rootState.claims.currentClaim.friendlyId, { root: true });

      return response;
    },

    async extractIban(_, { file } = {}) {
      if (!file) return null;

      const formData = new FormData();
      formData.append("document", file);

      const response = await IbanService.extractIban(formData);
      if (!response?.success) return null;

      return response.data?.iban ?? null;
    },
  },
};
